import { render, staticRenderFns } from "./SaleInvoice.vue?vue&type=template&id=56c499d3&"
import script from "./SaleInvoice.vue?vue&type=script&lang=js&"
export * from "./SaleInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports